import { render } from "./AppIcon.vue?vue&type=template&id=17b8e7a3"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"

import "./AppIcon.vue?vue&type=style&index=0&id=17b8e7a3&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__